import { useAuth0 } from '@auth0/auth0-react';

export function useAuthGuard() {
  const { isLoading, isAuthenticated, error } = useAuth0();

  return { isLoading, isAuthenticated, error };
}
